// extracted by mini-css-extract-plugin
module.exports = {"user-answers":"styles_user-answers__RYifn","table":"styles_table__m-iSC","row":"styles_row__LKUhM","answer":"styles_answer__3sn1F"};